import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/case-studies/voice-data-ai/page.tsx");
